export default Object.freeze({
    FMM: 'FMM',
    PERMANENT: 'PERMANENTE',
    TEMPORARY: 'TEMPORAL'
})
